module.exports = __webpack_public_path__ + "static/media/CardExample2.02e10c4e.png";